<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"></CommonBreadCrumbs>
    <div>
      <div class="text-center mx-4 md:mb-10 lg:mb-20 xl:mb-28 mb-4">
        <h1>{{ clinicData.data.title }}</h1>
      </div>
      <div class="bg-secondary-lighter md:relative md:overflow-hidden">
        <div class="flex md:flex-row flex-col md:max-w-7xl md:mx-auto md:h-[844px]">
          <div class="md:w-[40%] md:pt-14 pt-8">
            <ClinicMapList
              :mapText="mapText"
              :clinicLists="clinicLists"
              :showSearchBox="true"
              :isSearching="isSearching"
              @searchText="(data) => (mapSearchText = data)"
              @onTabClick="(data) => (showGoogleMap = data)"
              @clearSearch="clearClinicLists"
              :isMobile="isMobile"
              :popularCityList="popularCityList.data"
              :clinicSlug="clinicSlug"
              :listHeight="
                isNurseStationServiceEnabled ? 'h-auto max-h-[85vh] md:max-h-none md:h-[600px]' : 'h-auto md:h-[700px]'
              "
              @clinicTypeChanged="(val) => (clinicTypeFilter = val)"
            />
          </div>
          <ClientOnly>
            <div class="md:absolute md:w-[60%] map-container md:right-0" id="clinicSearchMap">
              <ClinicGoogleMap
                class="md:ml-8 large-desktop:ml-15 2xl:ml-20"
                onSearchShowAllCity
                @getClinicsList="setClinicLists"
                @markersReady="isSearching = false"
                :city="mapSearchText"
                :isMobile="isMobile"
                :showGoogleMap="showGoogleMap"
                :isClinicPage="true"
                :clinicTypeFilter="clinicTypeFilter"
              />
            </div>
          </ClientOnly>
          <div class="md:w-[60%] h-full hidden md:flex justify-center item-center">
            <NuxtImg class="w-20" src="/icons/loading.svg"></NuxtImg>
          </div>
        </div>
      </div>
      <NuxtLayout name="center">
        <div class="flex md:flex-row flex-col mt-12 md:my-12 lg:my-18">
          <ClinicContentLeft>
            <ClinicHelpBlock color=" bg-secondary-lighter" class="space-y-6"></ClinicHelpBlock>
          </ClinicContentLeft>
          <ClinicContentRight class="lg:mb-4">
            <h2 class="leading-[37px]">{{ $t("clinic.browse") }}</h2>
            <ClinicRegionList class="w-full md:my-8 lg:my-12 my-4" :dataLists="clinicData.regions"></ClinicRegionList>
          </ClinicContentRight>
        </div>
      </NuxtLayout>

      <ClinicDetail :clinicData="clinicData.data.body_text" class="mb-10 lg:mb-18"></ClinicDetail>
      <ClinicCTABlock class="mb-0 !h-auto"></ClinicCTABlock>
    </div>
  </div>
</template>
<script setup>
import { useGlobalStore } from "@/stores/global";
import { useMapStore } from "@/stores/map";
import { useProductStore } from "~/stores/filter";

const isMobile = ref(useScreenSize("sm"));
const handleScreenResize = () => {
  isMobile.value = useScreenSize("sm");
};

onMounted(() => {
  window.addEventListener("resize", handleScreenResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleScreenResize);
});

const { t } = useI18n();
const mapStore = useMapStore();
const productStore = useProductStore();
const globalStore = useGlobalStore();
const mapSearchText = ref("all");
const clinicLists = ref([]);
const filterOptions = ref({});
const showGoogleMap = ref(false);
const clinicTypeFilter = ref(["clinic", "nurse-station"]);
const isSearching = ref(false);

watch(mapSearchText, () => {
  isSearching.value = true;
});
const mapText = computed(() => {
  return mapSearchText.value ? t("clinic.selectClinicToSeeAvailableTest") : t("clinic.selectClinicToSeeAvailableTest");
});
const route = useRoute();
const clinicSlug = computed(() => route.query.slug);
const isNurseStationServiceEnabled = toRef(globalStore.siteNurseStationServiceEnabled);

const { data: clinicData } = await useClinicSearchDetail();
const { data: popularCityList } = await usePopularCitiesList();

filterOptions.value = await useFilterOptions();
productStore.setFilterOptions(filterOptions.value);

function setClinicLists(data) {
  if (mapSearchText.value && mapSearchText.value != "all") {
    clinicLists.value = data;
  } else {
    clinicLists.value = [];
  }
}
function clearClinicLists() {
  clinicLists.value = [];
}
useMetaTitles(clinicData.value.data, "clinics");

const breadcrumbs = getBreadcrumbs("clinics");
</script>
